/**
 * @prettier
 * @flow
 */
import CryptoJS from 'crypto-js';
import NodeRSA from 'node-rsa';

export function encryptAsymmetric(plaintext: string | {}, publicKey: string): string {
    publicKey = convertToPem(publicKey);
    const aes = encryptAes(JSON.stringify(plaintext));
    const rsaEncryptedAesKey = encryptRsa(aes.key, publicKey);

    return [rsaEncryptedAesKey, aes.cipher, aes.iv].join('$');
}

function convertToPem(publicKey: string): string {
    const publicKeyRows = publicKey.match(/.{1,64}/g);
    if (!publicKeyRows) {
        throw new Error('publicKey is not a valid PEM key');
    }
    return ['-----BEGIN PUBLIC KEY-----', ...publicKeyRows, '-----END PUBLIC KEY-----'].join('\n');
}

function encryptAes(plaintext: string) {
    const key = CryptoJS.lib.WordArray.random(32);
    const iv = CryptoJS.lib.WordArray.random(12);
    const cipher = CryptoJS.AES.encrypt(plaintext, key, { iv: iv });

    return {
        key: CryptoJS.enc.Base64.stringify(key),
        iv: CryptoJS.enc.Base64.stringify(iv),
        cipher: cipher.toString(),
    };
}

function encryptRsa(plaintext: string, publicKey: string) {
    const key = new NodeRSA(publicKey);
    return key.encrypt(plaintext, 'base64');
}
